(function () {
  'use strict';

  // Idempotenz: verhindert doppelten Listener bei mehreren Produkten pro Seite
  if (window.__supplementaProductVideosLoaded) return;
  window.__supplementaProductVideosLoaded = true;

  function getModal() {
    return document.getElementById('sp-video-modal');
  }

  function addParam(url, key, value) {
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + key + '=' + encodeURIComponent(value);
  }

  function buildEmbedUrl(rawUrl) {
    var url = rawUrl;
    if (/(?:youtube\.com|youtube-nocookie\.com|youtu\.be)/.test(url)) {
      url = addParam(url, 'autoplay', '1');
      url = addParam(url, 'rel', '0');
      url = addParam(url, 'modestbranding', '1');
    } else if (/vimeo\.com/.test(url)) {
      url = addParam(url, 'autoplay', '1');
    }
    return url;
  }

  function openModal(url, label) {
    var modal = getModal();
    if (!modal) return;

    var player = modal.querySelector('.sp-video-modal__player');
    var title = modal.querySelector('.sp-video-modal__title');

    title.textContent = label || '';

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', buildEmbedUrl(url));
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('title', label || 'Produktvideo');
    player.innerHTML = '';
    player.appendChild(iframe);

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      var closeBtn = modal.querySelector('.sp-video-modal__close');
      if (closeBtn) closeBtn.focus();
    }, 50);
  }

  function closeModal() {
    var modal = getModal();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    // iframe entfernen stoppt die Wiedergabe
    modal.querySelector('.sp-video-modal__player').innerHTML = '';
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sp-product-videos__btn');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.dataset.spVideoUrl, trigger.dataset.spVideoLabel);
      return;
    }
    if (e.target.closest('[data-sp-video-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
